<p-card>
  <div class="row">
    <div class="col-12">
      <h1 class="mb-3">Arrendamientos</h1>
      <p class="mb-3 text-color-secondary">
        Gestiona y revisa los detalles de los arrendamientos, incluyendo información sobre el cliente, el activo, el valor total, el plazo, las rentas anticipadas, la tasa de interés y el tipo de arrendamiento, utiliza los filtros para encontrar rápidamente la información necesaria.
      </p>
    </div>
    <p-toast></p-toast>
  </div>
  <div class="row">
    <div class="col-12">
      <p-tabView>
        <p-tabPanel header="Por Originar" leftIcon="fa-solid fa-hourglass-half">
          <app-main-table
            [apiService]="apiLeaseService"
            [columns]="porOriginarColumns"
            [additionalFilters]="porOriginarFilters"
            [pluralEntityName]="'arrendamientos por originar'"
            [additionalMainActions]="additionalMainActions"
            (onMainAction)="mainActions($event)"
            [actions]="actions"
            (onAction)="actionMethods($event)"
          ></app-main-table>
        </p-tabPanel>
        <p-tabPanel header="Activos" leftIcon="fa-solid fa-circle-check">
          <app-main-table
            [apiService]="apiLeaseService"
            [columns]="activosColumns"
            [additionalFilters]="activosFilters"
            [pluralEntityName]="'arrendamientos activos'"
            [actions]="actions"
            (onAction)="actionMethods($event)"
          ></app-main-table>
        </p-tabPanel>
        <p-tabPanel header="Cerrados" leftIcon="fa-solid fa-box-archive">
          <app-main-table
            [apiService]="apiLeaseService"
            [columns]="cerradosColumns"
            [additionalFilters]="cerradosFilters"
            [pluralEntityName]="'arrendamientos cerrados'"
            [actions]="actions"
            (onAction)="actionMethods($event)"
          ></app-main-table>
        </p-tabPanel>
      </p-tabView>
    </div>
  </div>
</p-card>
<!--Form to create or update a active-->
<p-dialog [(visible)]="createEntity" [style]="{ width: ' 700px' }" [header]="action === 'CREATE' ? 'Nuevo arrendamiento' : 'Actualizar arrendamiento'" [modal]="true" styleClass="p-fluid">
  <ng-template pTemplate="content">
     <app-lease-form-create></app-lease-form-create>
  </ng-template>
  <ng-template pTemplate="footer">
    <button pButton pRipple label="Cancel" icon="pi pi-times" class="p-button-text" (click)="hideDialog()" [disabled]="isSaving"></button>
    <button pButton pRipple label="Guardar" icon="pi pi-check" class="p-button-text" (click)="saveForm()" [disabled]="!leaseService.entity.valid || isSaving" [loading]="isSaving"></button>
  </ng-template>
</p-dialog>
<div class="card flex justify-content-center gap-2">
  <p-confirmDialog />
</div>
<!--End of form to create or update a active-->
